import {
  ChangeDetectionStrategy,
  Component,
  HostBinding,
  signal,
  ViewChild,
} from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { OrganizationMenuComponent } from '../organization-menu/organization-menu.component';

@Component({
  selector: 'app-sidebar',
  imports: [TranslatePipe, OrganizationMenuComponent],
  templateUrl: './sidebar.component.html',
  styleUrl: './sidebar.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SidebarComponent {
  private readonly organizationRailExpanded = signal(false);

  @ViewChild(OrganizationMenuComponent)
  private organizationMenu?: OrganizationMenuComponent;

  @HostBinding('class.organization-rail-expanded')
  protected get isOrganizationRailExpanded(): boolean {
    return this.organizationRailExpanded();
  }

  protected setOrganizationRailExpanded(expanded: boolean): void {
    this.organizationRailExpanded.set(expanded);
  }

  protected closeOrganizationRail(): void {
    this.organizationMenu?.closeSelector();
  }
}
